import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '../../../../utils/i18n';

import './PageFooter.scss';

function PageFooter(props) {
  const { t } = useTranslation();
  const lang = getLanguage();
  const [footerLinks, setFooterLinks] = useState([]);
  const [footerGoals, setFooterGoals] = useState([]);

  useEffect(() => {
    ReactGA.initialize('G-949P9BMNVS');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  useEffect(() => {
    const url = `./header_footer_CEPALSTAT/json_footer_links.json`;

    fetch(url)
      .then(res => res.json())
      .then(links => {
        setFooterLinks(links);
      });
  }, []);

  useEffect(() => {
    const url = `./header_footer_CEPALSTAT/json_footer_goals.json`;

    fetch(url)
      .then(res => res.json())
      .then(goals => {
        setFooterGoals(goals);
      });
  }, []);

  return (
    <>
      <p>&nbsp;</p>
      <div className="footer-color footer-color-1 footer-line-1">
        <div className="container">
          <div className="row ">
            <div
              className="col-xs-12 col-sm-12 col-lg-6"
              style={{ marginTop: '12px' }}
            >
              {t('getAgendaUpdates')}
              &nbsp;&nbsp;
              <button
                type="button"
                className="btn btn-light btn-sm footer-button-1"
                style={{ fontSize: '14px' }}
                onClick={() =>
                  window.open(
                    `https://cepal.org/${lang}/suscripciones`,
                    '_blank'
                  )
                }
              >
                {t('subscribe')}
              </button>
            </div>
            <div className="col-xs-12 col-sm-12 col-lg-6" align="right">
              &nbsp;
            </div>
          </div>
        </div>
      </div>

      <div className="footer-color">
        <div className="container">
          <div className="row footer-line-2">
            <div className="col-xs-12 col-sm-12 col-lg-4">
              <ul className="footer-list" id="link_col_1">
                {footerLinks.map(record => {
                  const column = parseInt(record.column);
                  const type = record.type;
                  const name = lang === 'es' ? record.name_es : record.name_en;
                  const link = lang === 'es' ? record.link_es : record.link_en;

                  if (column === 1) {
                    if (type === 'title') {
                      return (
                        <li className="footer-link-title-1">
                          <a href={link}>{name}</a>
                        </li>
                      );
                    } else {
                      return (
                        <ul className="footer-link-list-1">
                          <li>
                            <a href={link}>{name}</a>
                          </li>
                        </ul>
                      );
                    }
                  }
                  return null;
                })}
              </ul>
            </div>
            <div className="col-xs-12 col-sm-12 col-lg-5">
              <ul className="footer-list" id="link_col_2">
                {footerLinks.map(record => {
                  const column = parseInt(record.column);
                  const type = record.type;
                  const name = lang === 'es' ? record.name_es : record.name_en;
                  const link = lang === 'es' ? record.link_es : record.link_en;

                  if (column === 2) {
                    if (type === 'title') {
                      return (
                        <li className="footer-link-title-1">
                          <a href={link}>{name}</a>
                        </li>
                      );
                    } else {
                      return (
                        <ul className="footer-link-list-1">
                          <li>
                            <a href={link}>{name}</a>
                          </li>
                        </ul>
                      );
                    }
                  }
                  return null;
                })}
              </ul>
            </div>
            <div className="col-xs-12 col-sm-12 col-lg-3">
              <ul className="footer-list" id="link_col_3">
                {footerLinks.map(record => {
                  const column = parseInt(record.column);
                  const type = record.type;
                  const name = lang === 'es' ? record.name_es : record.name_en;
                  const link = lang === 'es' ? record.link_es : record.link_en;

                  if (column === 3) {
                    if (type === 'title') {
                      return (
                        <li className="footer-link-title-1">
                          <a href={link}>{name}</a>
                        </li>
                      );
                    } else {
                      return (
                        <ul className="footer-link-list-1">
                          <li>
                            <a href={link}>{name}</a>
                          </li>
                        </ul>
                      );
                    }
                  }
                  return null;
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-color">
        <div className="container">
          <div className="row footer-line-2">
            <div className="col-xs-12 col-sm-12 col-lg-12">
              <div className="footer-list-title-center">
                {t('sdgProfilesByTarget')}
              </div>
              <br />

              <div
                id="footerSDGmenu"
                style={{ border: '1px none #f00', marginRight: '-40px' }}
              >
                {footerGoals.map(record => {
                  const ii = record.goal;
                  const vinculo =
                    lang === 'es' ? record.link_es : record.link_en;
                  const imgPath = `./header_footer_CEPALSTAT/images_header_cepalstat/ods/${ii}_${lang}_c.png`;

                  return (
                    <div style={{ float: 'left', marginRight: '15px' }}>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={
                          'https://agenda2030lac.org/estadisticas/' + vinculo
                        }
                      >
                        <img
                          alt={'ods' + ii}
                          src={imgPath}
                          height="50px"
                          style={{ marginBottom: '15px' }}
                        />
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-color">
        <div className="container">
          <div className="row footer-line-2 footer-line-3">
            <div className="col-xs-12 col-sm-12 col-lg-12" align="center">
              <a
                href={`https://www.cepal.org/${lang}/c-cepal-naciones-unidas`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('foot_copyright')}
              </a>
              &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
              <a
                href={`https://www.cepal.org/${lang}/terminos-y-condiciones-sobre-el-uso-del-sitio-web-entre-la-cepal-y-el-usuario`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('termsAndConditions')}
              </a>
              &nbsp;&nbsp;&nbsp;
              <a
                href={
                  lang === 'es'
                    ? 'https://www.cepal.org/es/areas-de-trabajo/estadisticas'
                    : 'https://www.cepal.org/en/work-areas/statistics'
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('contact')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PageFooter;
